<template>
  <v-container fluid class="paymethod-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Pay Method</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Pay Method</p>
                        <v-text-field
                          class="mb-4"
                          v-model="paymethod.paymethodcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Pay Method Code"
                          persistent-hint
                          single-line hint="Enter the pay method Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="paymethod.paymethodname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Pay Method Name"
                          persistent-hint
                          single-line hint="Enter the pay method name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="paymethod.paymethodtype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the pay method type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="['USD', 'SGD', 'KHR', 'MMK', 'THB']"
                          v-model="paymethod.paymethodcurrency"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Currency"
                          persistent-hint
                          single-line hint="Please choose the currency">
                        </v-select>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          outlined
                          dense
                          v-model="paymethod.paymethoddiscount"
                          v-bind:error="errorindex == 4"
                          placeholder="Pay Method Discount"
                          persistent-hint
                          single-line hint="Enter the pay method discount">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          outlined
                          v-model="paymethod.paymethodinfo"
                          rows="3"
                          label="Pay Method Info"
                          hint="please enter the pay method info"
                        ></v-textarea>
                        <v-textarea
                          v-model="paymethod.paymethoddata"
                          outlined
                          rows="5"
                          label="Data"
                          hint="please enter the data"
                        ></v-textarea>
                        <v-switch
                          v-model="paymethod.paymethodstatus"
                          color="primary"
                          v-bind:label="paymethod.paymethodstatus"
                          value="Active"
                        ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/paymethod/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertPayMethod()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      paymethod: {
        paymethodstatus: 'Active'
      },
      items: ['Cash', 'Api Gateway', 'Qr Code'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('PayMethod', ['insertPayMethodRequest','getPayMethodsRequest']),
    checkError(){
      if(!this.paymethod.paymethodcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.paymethod.paymethodname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.paymethod.paymethodtype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.paymethod.paymethodcurrency){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.paymethod.paymethoddiscount){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertPayMethod() {
      await this.insertPayMethodRequest(this.paymethod);
      router.push('/paymethod/list')
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.paymethod.imagefile = file;
      this.paymethod.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('PayMethod', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
